import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Modal from "../components/Modal";
import axios from "axios";

function FieldGroup({ id, label, help, ...props }) {
  return (
    <div className="registration-form-element">
      <br />
      <label className="registration-form-label">
        <b>{label}</b>
        <br />
        {help ? help : null}
      </label>
      <input
        style={props.validate === false ? { borderColor: "red" } : null}
        className="registration-form-control"
        type={props.type}
        accept={props.type === "file" ? "application/zip" : ""}
        placeholder={props.placeholder}
        onChange={props.onChange}
      />
      <br />
      <p style={{ color: "red" }}>
        {props.validate === false ? props.validateText : null}
      </p>
    </div>
  );
}

class FormTemplate extends Component {
  constructor() {
    super();

    this.state = {
      companiesLoaded: false,
      disabled: true,
      isConnected: false,
      showModal: false,
      modalState: 2,
      registrationSuccess: false,

      title: "Carousell Login",
      description:
        "We will not disclose your Carousell account to reported users.",
      modalHelpText: "",
      disableConfirm: true,

      username: "",
      password: "",

      firstName: "",
      lastName: "",
      contactEmail: "",
      supportEmail: "",
      phoneNumber: "",
      documentsUrl: "",
      notes: "",

      brands: [],
      companyName: "",
      companyID: "",
    };
  }

  toggleModal() {
    this.setState({ showModal: !this.state.showModal });
  }

  toggleIsConnected() {
    this.setState({ isConnected: !this.state.isConnected });
  }

  clearFile() {
    this.setState({ file: "" });
  }

  handleOnSubmit() {
    this.handleLogin();
  }

  validateInput(input, pattern) {
    var re = pattern;
    return re.test(input);
  }

  onValueChange(event) {
    if (event.target.id === "username") {
      this.setState({
        username: event.target.value,
      });
    }

    if (event.target.id === "password") {
      this.setState({
        password: event.target.value,
      });
    }
  }

  getBase64(file, callback) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      callback(reader.result);
    };
    reader.onerror = function (error) {};
  }

  handleFileUpload(event) {
    //base64 encode && upload file
    let fileEncoded = "";
    this.getBase64(event.target.files[0], (res) => {
      fileEncoded = res;
      fileEncoded = fileEncoded.replace(/data:.+?,/, "");
      this.setState({ file: fileEncoded });
    });
    this.setState({ filename: event.target.files[0].name });
  }

  handleSubmitForm(event) {
    event.preventDefault();

    const formFields = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      contact_email: this.state.contactEmail,
      support_email: this.state.supportEmail,
      phone_number: this.state.phoneNumber,
      url: this.state.documentsUrl,
      notes: this.state.notes,
    };

    //register optional fields
    if (this.props.registrationType === "agent") {
      formFields["company_reg_num"] = this.state.companyID;
    } else {
      formFields["company_name"] = this.state.companyName;
      formFields["company_reg_num"] = this.state.companyID;
    }

    var options = {};
    var route;

    if (this.props.registrationType === "agent") {
      route = "registeruser";
      let header = {
        Authorization: "Bearer " + localStorage.getItem("carousellAuthToken"),
        "Content-Type": "application/json",
      };
      options = {
        headers: header,
      };
    } else {
      route = "registerbrand";
      options = {
        headers: {
          "Content-Type": "application/json",
        },
      };
    }

    axios
      .post(`/crop/${route}`, formFields, options)
      .then((response) => {
        if (response.data.status === 1) {
          this.setState({ registrationSuccess: true });
        } else if (response.data.status === 2) {
          // quick hack, sorry.
          this.setState({ registrationSuccess: 2 });
        }

        this.props.history.push({
          pathname: "/confirmation",
          state: {
            success: this.state.registrationSuccess,
          },
        });
      })
      .catch((response) => {
      });
  }

  handleLogin() {
    var self = this;
    var querystring = require("querystring");

    let data = querystring.stringify({
      username: this.state.username,
      password: this.state.password,
    });

    // call carousell api
    axios
      .post("/crop/login/", data)
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("carousellAuthToken", response.data.token);

          self.setState({
            isConnected: true,
            user_id: response.data.userId,
          });
          this.toggleModal();
        }
      })
      .catch(this.setState({ modalHelpText: "Please try again." }));
  }

  LoginComponent() {
    return (
      <div className="login-container">
        <form id="login-form" className="login-form" autoComplete="off">
          <div className="login-form-block">
            <label htmlFor="username" className="login-form-elem">
              Username
            </label>
            <input
              onChange={this.onValueChange.bind(this)}
              id="username"
              className="login-form-input-elem"
              required
            />
          </div>
          <div className="login-form-block">
            <label htmlFor="password" className="login-form-elem">
              Password
            </label>
            <input
              onChange={this.onValueChange.bind(this)}
              type="password"
              id="password"
              className="login-form-input-elem"
              required
            />
          </div>
        </form>
      </div>
    );
  }

  getBrands() {
    axios
      .post("/crop/getbrands", "{}")
      .then((response) => {
        return response.data.brands;
      })
      .then((data) => {
        if (data !== null) {
          let brands = data.map((brand) => {
            return { value: brand.id, display: brand.company_name };
          });
          let selected = brands.filter(
            (brand) => brand.value !== "2123123141r13f"
          );
          this.setState({
            brands: [{ value: "", display: "(Select your company)" }].concat(
              selected
            ),
            companiesLoaded: true,
          });
        } else {
        }
      });
  }

  componentDidMount() {
    this.getBrands();
  }

  render() {
    const disableLogin =
      (this.state.username.length === 0) | (this.state.password.length === 0);
    const enableSubmit =
      this.props.registrationType === "agent"
        ? this.state.isConnected === true &&
          this.state.documentsUrl !== "" &&
          this.state.companyID !== ""
          ? false
          : true
        : this.state.contactEmail &&
          this.state.companyID !== "" &&
          this.state.file !== ""
        ? false
        : true;
    const emailRe =
      /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
    const phoneNumber =
      /(\+|00)(297|93|244|1264|358|355|376|971|54|374|1684|1268|61|43|994|257|32|229|226|880|359|973|1242|387|590|375|501|1441|591|55|1246|673|975|267|236|1|61|41|56|86|225|237|243|242|682|57|269|238|506|53|5999|61|1345|357|420|49|253|1767|45|1809|1829|1849|213|593|20|291|212|34|372|251|358|679|500|33|298|691|241|44|995|44|233|350|224|590|220|245|240|30|1473|299|502|594|1671|592|852|504|385|509|36|62|44|91|246|353|98|964|354|972|39|1876|44|962|81|76|77|254|996|855|686|1869|82|383|965|856|961|231|218|1758|423|94|266|370|352|371|853|590|212|377|373|261|960|52|692|389|223|356|95|382|976|1670|258|222|1664|596|230|265|60|262|264|687|227|672|234|505|683|31|47|977|674|64|968|92|507|64|51|63|680|675|48|1787|1939|850|351|595|970|689|974|262|40|7|250|966|249|221|65|500|4779|677|232|503|378|252|508|381|211|239|597|421|386|46|268|1721|248|963|1649|235|228|66|992|690|993|670|676|1868|216|90|688|886|255|256|380|598|1|998|3906698|379|1784|58|1284|1340|84|678|681|685|967|27|260|263)(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{4,20}$/;

    return (
      <div className="Home">
        <div className="registration-header-box">
          <h1 className="about-title">Sign up for an account</h1>
        </div>

        {this.props.registrationType === "agent" ? (
          this.state.isConnected ? (
            <div>
              Connected account:{" "}
              <a href={"http://www.carousell.com/" + this.state.username}>
                {this.state.username}
              </a>
              <br />
              <button onClick={this.toggleIsConnected.bind(this)}>
                Disconnect
              </button>
            </div>
          ) : (
            <div className="registration-container">
              <button
                onClick={this.toggleModal.bind(this)}
                className="login-button"
                type="button"
              >
                Login with Carousell
              </button>
              <br />
              <br />
              A Carousell account is required to create an agent account on
              CROP.
              <br />
              <a href={"https://www.carousell.com/"}>
                Don't have a Carousell account?
              </a>
              <br />
              <Modal
                show={this.state.showModal}
                modalState={this.state.modalState}
                toggleModalState={this.toggleModal.bind(this)}
                customComponent={this.LoginComponent()}
                title={this.state.title}
                description={this.state.description}
                help={this.state.modalHelpText}
                disableConfirm={!!disableLogin}
                confirmFunction={this.handleOnSubmit.bind(this)}
              />
            </div>
          )
        ) : null}

        <br />
        <br />
        <div className="registration-container">
          <form
            className="registration-form"
            onSubmit={this.handleSubmitForm.bind(this)}
          >
            {this.props.registrationType === "brand" ? (
              <h2>Manager Details</h2>
            ) : null}
            <FieldGroup
              id="firstName"
              type="text"
              label="First Name"
              placeholder="John"
              onChange={(e) => this.setState({ firstName: e.target.value })}
            />
            <FieldGroup
              id="lastName"
              type="text"
              label="Last Name"
              placeholder="Doe"
              onChange={(e) => this.setState({ lastName: e.target.value })}
            />
            <FieldGroup
              id="phoneNumber"
              validate={this.validateInput(this.state.phoneNumber, phoneNumber)}
              validateText="Please include relevant country/area codes (ie. +65)"
              type="text"
              label="Contact Number"
              onChange={(e) => this.setState({ phoneNumber: e.target.value })}
              help="Your number is only used for us to contact you. It will not be disclosed to Carousell users."
            />
            <FieldGroup
              id="contactEmail"
              validate={this.validateInput(this.state.contactEmail, emailRe)}
              validateText="Please enter a valid email address."
              type="email"
              label="Contact Email"
              placeholder="eg. anna@abc.com"
              onChange={(e) => this.setState({ contactEmail: e.target.value })}
              help="Please provide your work email."
            />
            <FieldGroup
              id="supportEmail"
              validate={this.validateInput(this.state.supportEmail, emailRe)}
              validateText="Please enter a valid email address."
              type="email"
              label="Support Email"
              onChange={(e) => this.setState({ supportEmail: e.target.value })}
              placeholder="eg. support@abc.com"
              help="Please provide the email that you would like users to contact you with."
            />
            <br />

            <h2>Company Details</h2>

            {this.props.registrationType !== "agent" ? (
              <div>
                <FieldGroup
                  id="companyName"
                  type="text"
                  label="Company Name"
                  placeholder="Carousell Pte Ltd"
                  onChange={(e) =>
                    this.setState({ companyName: e.target.value })
                  }
                />
                <FieldGroup
                  id="companyRegNum"
                  type="text"
                  label="Company Registration No."
                  placeholder="12345d"
                  onChange={(e) => this.setState({ companyID: e.target.value })}
                />{" "}
              </div>
            ) : this.state.companiesLoaded === true ? (
              <select
                value={this.state.companyID}
                onChange={(e) => this.setState({ companyID: e.target.value })}
              >
                {this.state.brands.map((brand) => (
                  <option key={brand.value} value={brand.value}>
                    {brand.display}
                  </option>
                ))}
              </select>
            ) : (
              <div>
                No companies available. Please ensure you are connected to the
                internet.
              </div>
            )}

            <h2>Required Documents</h2>
            <text className="registration-text-block">
              Please submit a copy of the following documents in order for
              Carousell to effectively process any infringement reports from the
              company:
              <br />
              <ul>
                {this.props.registrationType === "brand" ? (
                  <li>
                    Documented evidence to identify the intellectual property
                    that the company owns, including its registration
                    information and jurisdiction of applicable intellectual
                    property right.
                  </li>
                ) : (
                  <li>
                    Document(s) which can identify the authorised
                    representative(s) and the company (e.g. proof of employment,
                    legal representative) and a physical or electronic signature
                    of the person(s) authorised to act on behalf of the owner of
                    the copyright that is allegedly infringed.{" "}
                  </li>
                )}
                <br />
              </ul>
            </text>

            <div className="registration-container">
              <FieldGroup
                id="documentsUrl"
                type="text"
                placeholder="www.droppedboxes.com/1234"
                label="Please provide the link to download your documents and make sure read access has been given to crop@thecarousell.com."
                onChange={(e) =>
                  this.setState({ documentsUrl: e.target.value })
                }
              />
            </div>

            <div style={{ marginBottom: "10vh" }}>
              <textarea
                onChange={(e) => {
                  this.setState({ notes: e.target.value });
                }}
                className="registration-notes"
                placeholder={`Additional notes...`}
              />
            </div>

            <div className="login-form-block">
              <button
                className="login-button"
                type="submit"
                style={
                  enableSubmit
                    ? { background: "grey", cursor: "not-allowed" }
                    : null
                }
                disabled={enableSubmit}
                onSubmit={this.handleSubmitForm.bind(this)}
              >
                Submit Form
              </button>
            </div>
          </form>
          <br />
        </div>
      </div>
    );
  }
}

export default withRouter(FormTemplate);



// WEBPACK FOOTER //
// ./src/containers/RegistrationForm.js